export default __webpack_public_path__ + "ea8d9ea2fc804a78103c3c5c5f6b02df.png";